<template>
  <el-popover
    v-if="stats"
    placement="bottom"
    width="200"
    class="stats-popover"
    trigger="hover">
    <div class="stats">
      <div v-for="(v, k) in stats" :key="k">
        <span v-if="v > 0"><b>{{ normalizeString(k) }} :</b> {{ v }}</span>
      </div>
    </div>

    <button slot="reference"
            class="stats-button"
            :style="!showStats ? 'pointer-events: none;': ''">
      <span>{{ `${$t("Total")} ${total}` }}</span>
      <i v-if="showStats" class="el-icon-info" />
    </button>
  </el-popover>
</template>

<script>
export default {
  name: 'VisitListStats',
  props: {
    stats: {
      type: Object,
      default: () => ({})
    },
    total: {
      type: Number,
      default: 0
    },
    showStats: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>

.stats-button {
  display: flex;
  align-items: center;
  padding: 8px !important;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  background: #fff;
  border: none !important;
  border-radius: 999px;

  i {
    margin-left: 10px;
    font-size: 20px;
    color: $darkSkyBlue;
  }
}
</style>
